import Container from 'typedi';
import { GTMDataLayerToken } from '../../../../injection-tokens';
import { Utils } from '../../../utils';

export const pushDataLayerData = () => {
    const dataLayer = Container.get(GTMDataLayerToken);
    const utils = Container.get(Utils);
    dataLayer?.push({ isNative: utils.findIfIsNative() });
};
